export var locations = [{
  locationId: 1,
  name: "ulm",
  legalEntityId: 10,
  country: "DE"
}, {
  locationId: 3,
  name: "hamburg",
  legalEntityId: 10,
  country: "DE"
}, {
  locationId: 5,
  name: "amsterdam",
  legalEntityId: 1,
  country: "NL"
}, {
  locationId: 6,
  name: "lyon",
  legalEntityId: 3,
  country: "FR"
}, {
  locationId: 7,
  name: "vienna",
  legalEntityId: 2,
  country: "AT"
}, {
  locationId: 12,
  name: "berlin",
  legalEntityId: 10,
  country: "DE"
}, {
  locationId: 18,
  name: "stuttgart",
  legalEntityId: 10,
  country: "DE"
}, {
  locationId: 19,
  name: "rhineland",
  legalEntityId: 10,
  country: "DE"
}, {
  locationId: 20,
  name: "milan",
  legalEntityId: 20,
  country: "IT"
}, {
  locationId: 26,
  name: "munich",
  legalEntityId: 10,
  country: "DE"
}, {
  locationId: 31,
  name: "rome",
  legalEntityId: 20,
  country: "IT"
}, {
  locationId: 33,
  name: "frankfurt",
  legalEntityId: 10,
  country: "DE"
}, {
  locationId: 36,
  name: "madrid",
  legalEntityId: 23,
  country: "ES"
}, {
  locationId: 37,
  name: "florence",
  legalEntityId: 20,
  country: "IT"
}, {
  locationId: 44,
  name: "turin",
  legalEntityId: 20,
  country: "IT"
}, {
  locationId: 48,
  name: "paris",
  legalEntityId: 3,
  country: "FR"
}, {
  locationId: 49,
  name: "helsinki",
  legalEntityId: 31,
  country: "FI"
}, {
  locationId: 50,
  name: "lisbon",
  legalEntityId: 28,
  country: "PT"
}, {
  locationId: 51,
  name: "london",
  legalEntityId: 29,
  country: "UK"
}, {
  locationId: 52,
  name: "copenhagen",
  legalEntityId: 37,
  country: "DK"
}, {
  locationId: 54,
  name: "brussels",
  legalEntityId: 27,
  country: "BE"
}, {
  locationId: 55,
  name: "budapest",
  legalEntityId: 32,
  country: "HU"
}, {
  locationId: 56,
  name: "muenster",
  legalEntityId: 38,
  country: "DE"
}];

var throwCityNotFoundError = function throwCityNotFoundError(errorMessage) {
  throw new Error(errorMessage);
};

export var findLocationByName = function findLocationByName(cityName) {
  var _a;

  return (_a = locations.find(function (city) {
    return city.name.toLowerCase() === cityName.toLowerCase();
  })) !== null && _a !== void 0 ? _a : throwCityNotFoundError("Location with name \"".concat(cityName, "\" does not exist"));
};
export var findLocationById = function findLocationById(cityId) {
  var _a;

  return (_a = locations.find(function (city) {
    return city.locationId === Number(cityId);
  })) !== null && _a !== void 0 ? _a : throwCityNotFoundError("Location with locationId \"".concat(cityId, "\" does not exist"));
};